/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemStatusSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  color: z.string(),
  createdAt: z.iso.datetime(),
  default: z.boolean(),
  id: z.int(),
  name: z.string(),
  priority: z.string(),
  schedulingType: z.enum(['IN_PROGRESS', 'TO_DO', 'DONE']),
  updatedAt: z.iso.datetime(),
});
